import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53a103c5")

_pushScopeId("data-v-53a103c5")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Menu")
const _hoisted_2 = {
  key: 0,
  class: "menu_notification_container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "logo_ingegno" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_menu = _resolveComponent("ion-menu")

  return (_openBlock(), _createBlock(_component_ion_menu, {
    "menu-id": "app-menu",
    "content-id": "main-content"
  }, {
    default: _withId(() => [
      _createVNode(_component_ion_header, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          (!$setup.notificationsEnabled && $setup.showNotificationButton)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.enableNotifications && $setup.enableNotifications(...args))),
                  class: "menu_notification_button",
                  disabled: $setup.isEnablingNotifications
                }, [
                  _createVNode(_component_ion_icon, {
                    icon: $setup.notificationsOutline,
                    class: "menu_notification_icon"
                  }, null, 8, ["icon"]),
                  ($setup.isEnablingNotifications)
                    ? (_openBlock(), _createBlock("span", _hoisted_3, "Abilitazione..."))
                    : (_openBlock(), _createBlock("span", _hoisted_4, "Abilita notifiche"))
                ], 8, ["disabled"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_list, { lines: "none" }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.filteredMenuItems, (item, i) => {
                return (_openBlock(), _createBlock("span", { key: i }, [
                  (item.show)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        onClick: ($event: any) => ($setup.changePage(item.route)),
                        class: "menu_border_bottom"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_icon, {
                            icon: item.icon,
                            slot: "start"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu_title" }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createVNode(_component_ion_item, { onClick: $setup.openSimulator }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    icon: $setup.informationCircle,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, { class: "menu_title" }, {
                    default: _withId(() => [
                      _createTextVNode("Versione " + _toDisplayString($setup.appVersion), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              src: $setup.getAssetUrl('assets/logo_ingegno.png')
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})